import { useEffect } from "react";
import { business } from "@/data/site";

// Lightweight SEO: sets document title, meta description, and optional JSON-LD schema.
export function useSeo({ title, description, jsonLd, canonical }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);

    // canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    // JSON-LD schema
    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }

    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
    };
  }, [title, description, jsonLd, canonical]);
}

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "HVACBusiness",
  name: business.name,
  description: "Plumbing, electrical, and HVAC contractor serving New York.",
  telephone: business.phoneDisplay,
  email: business.email,
  areaServed: "New York, NY",
  address: {
    "@type": "PostalAddress",
    streetAddress: "123 Broadway Ave, Suite 400",
    addressLocality: "New York",
    addressRegion: "NY",
    postalCode: "10007",
    addressCountry: "US",
  },
  openingHours: "Mo-Fr 07:00-19:00, Sa 08:00-16:00",
  priceRange: "$$",
};
